import {
	PERFORMER_SEGMENT,
	PerformerSegmentKey,
} from '../../utils/SupplierPerformerSegmentationUtils';
import { isFiniteNumber } from '../../utils/DataAccessUtils';

export const SUPPLIER_PERFORMANCE_CHART_KEY = 'supplier_performance';

export const LOCATIONS_DROPDOWN_COLLECTION = 'locationsAnalyticsDropdown';
export const SUPPLIER_FACILITIES_DROPDOWN_COLLECTION = 'supplierFacilitiesAnalyticsDropdown';
export const PROBLEM_TYPES_DROPDOWN_COLLECTION = 'analyticsProblemTypesDropDown';
export const WORK_ORDER_PRIORITIES_DROPDOWN_COLLECTION = 'analyticsWorkOrderPrioritiesDropDown';
export const BACK_LINK_TEXT = 'Back to Supplier Performance';
export const MAX_SUPPLIERS_IN_CHART = 35;
export const MAX_SUPPLIER_LABEL_CHARS = 20;
export const DEFAULT_MIN_WO_COUNT = 1;
export const DEFAULT_COMPLETED_AT_SPAN_MONTHS = 6;

export const PERFORMER_GROUP_LABELS: Record<PerformerSegmentKey, string> = {
	[PERFORMER_SEGMENT.TOP]: 'Top Performers',
	[PERFORMER_SEGMENT.TYPICAL]: 'Typical Performers',
	[PERFORMER_SEGMENT.BOTTOM]: 'Bottom Performers',
};

export const PERFORMER_GROUP_LABEL_ORDER = [
	PERFORMER_GROUP_LABELS[PERFORMER_SEGMENT.TOP],
	PERFORMER_GROUP_LABELS[PERFORMER_SEGMENT.TYPICAL],
	PERFORMER_GROUP_LABELS[PERFORMER_SEGMENT.BOTTOM],
];

export const COMPARISON_CURRENT_POINT_SIZE = 6;
export const COMPARISON_PREVIOUS_POINT_SIZE = 4;
export const COMPARISON_PREVIOUS_BORDER_COLOR = '#bfbfbf';
export const COMPARISON_CONNECTOR_COLOR = '#d9d9d9';
export const COMPARISON_CONNECTOR_OPACITY = 0.6;
export const COMPARISON_CONNECTOR_LINE_WIDTH = 2;
export const COMPARISON_CONNECTOR_LINE_DASH: [number, number] = [8, 4];
export const COMPARISON_POINT_BORDER_WIDTH = 2;
export const COMPARISON_POINT_FILL = '#FFF';

export const isValidComparisonConnectorEdge = (
	previousX: number,
	previousY: number,
	currentX: number,
	currentY: number
) => {
	if (!isFiniteNumber(previousX) || !isFiniteNumber(previousY)) {
		return false;
	}
	if (!isFiniteNumber(currentX) || !isFiniteNumber(currentY)) {
		return false;
	}
	if (previousX === currentX && previousY === currentY) {
		return false;
	}
	return true;
};

export const buildComparisonConnectorEdgeStyle = () => ({
	stroke: COMPARISON_CONNECTOR_COLOR,
	strokeOpacity: COMPARISON_CONNECTOR_OPACITY,
	lineWidth: COMPARISON_CONNECTOR_LINE_WIDTH,
	lineDash: COMPARISON_CONNECTOR_LINE_DASH,
	endArrow: true,
});
